module.exports = __webpack_public_path__ + "media/2.643f110a.wav";